import { Subject } from 'rxjs';
import { FilterRule } from '../../../../shared/interfaces/filters/filter-rule.type';
import { IFiltersOption } from '../../interfaces/sections/filters-option.interface';

export class FiltersOption implements IFiltersOption {
  filterMethod: string;
  description?: string;
  filterMethodConfig: any;
  filterPropertyKeys: string[];
  filterRules: FilterRule[];
  filterValueType?: 'OBJECT_ID' | 'DATE';
  entityValueField?: string;

  patchRulesSubject: Subject<any>;
  preInitPatchRules: FilterRule[];

  definitionAlias?;

  optionId?;

  constructor(init: IFiltersOption) {
    Object.assign(this, init);
    this.patchRulesSubject = new Subject<any>();
  }
}
